import { wrap } from "@/utils/globals"
import useAppAuthProvider, { useAppAuthProviderProps } from "./hooks/useAppAuthProvider"
import AppAuthProviderView from "./views/AppAuthProviderView"

const AppAuthProvider: React.FC<useAppAuthProviderProps> = wrap(AppAuthProviderView, useAppAuthProvider)
export default AppAuthProvider
